var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-item",class:{ 'item--selected': _vm.id === _vm.selectedTagId },on:{"click":function($event){return _vm.select(_vm.id)}}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }